export const COLOR_HEADER_DARK_RED = "var(--color-header-dark-red)";
export const COLOR_TEXT_WHITE = "var(--color-text-white)";
export const COLOR_CELL_DARK_RED = "var(--color-cell-dark-red)";
export const COLOR_TEXT_BLACK = "var(--color-text-black)";
export const COLOR_HEADER_WHITE = "var(--color-header-white)";
export const COLOR_TEXT_DARK_GRAY = "var(--color-text-dark-gray)";
export const COLOR_CELL_WHITE = "var(--color-cell-white)";
export const COLOR_HEADER_TURQUOISE = "var(--color-header-turquoise)";
export const COLOR_CELL_TURQUOISE = "var(--color-cell-turquoise)";
export const COLOR_HEADER_ORANGE = "var(--color-header-orange)";
export const COLOR_CELL_ORANGE = "var(--color-cell-orange)";
export const COLOR_HEADER_VIOLET = "var(--color-header-violet)";
export const COLOR_CELL_VIOLET = "var(--color-cell-violet)";
export const COLOR_HEADER_DARK_BLUE = "var(--color-header-dark-blue)";
export const COLOR_CELL_DARK_BLUE = "var(--color-cell-dark-blue)";
export const COLOR_HEADER_DARK_VIOLET = "var(--color-header-dark-violet)";
export const COLOR_CELL_DARK_VIOLET = "var(--color-cell-dark-violet)";
export const COLOR_HEADER_YELLOW = "var(--color-header-yellow)";
export const COLOR_CELL_YELLOW = "var(--color-cell-yellow)";
export const COLOR_HEADER_GREEN = "var(--color-header-green)";
export const COLOR_CELL_GREEN = "var(--color-cell-green)";
export const COLOR_HEADER_GRAY = "var(--color-header-gray)";
export const COLOR_CELL_GRAY = "var(--color-cell-gray)";
export const COLOR_HEADER_RED = "var(--color-header-red)";
export const COLOR_CELL_RED = "var(--color-cell-red)";
